import owd from 'owd/owd';
import _ from 'underscore';

export default class Accordion extends owd.Component {
	init() {
		this.$item = this.$element.find('[data-accordion-item]');
		this.$button = this.$item.find('[data-accordion-button]');
		this.itemsOffsets = [];

		this.bind();
	}

	calc() {
		this.$element.addClass('is-calculating');

		this.$item.each((i, obj) => {
			$(obj).prop('maxHeight', $(obj).outerHeight() + $(obj).find('[data-accordion-content]').outerHeight())
				  .prop('minHeight', $(obj).outerHeight())

			if ( $(obj).is('[data-accordion-item="initially-expanded"]') ) {
				$(obj).outerHeight($(obj).prop('maxHeight'));
			}
		});

		this.$element.removeClass('is-calculating');
	}


	bind() {
		this.on('load ajaxload resize-x', this.dom.$window, (e) => {
			this.calc();

			this.$item.not('[data-accordion-item="initially-expanded"]').each((i, obj) => {
				$(obj).addClass('is-reduced')
				    .outerHeight($(obj).prop('minHeight'));
			});
		});

		this.on('click', this.$button, (e) => {
            var $ancestor = $(e.target).parent();

			if ($ancestor.hasClass('is-reduced')) {
				$ancestor.removeClass('is-reduced')
				.outerHeight($ancestor.prop('maxHeight'));
			} else {
				$ancestor.addClass('is-reduced')
				.outerHeight($ancestor.prop('minHeight'));
			}
		});

		this.on('resize-x', this.dom.$window, (e) => {
			this.$item.outerHeight('');
			this.calc();

			this.$element.find('.is-reduced').each((i, obj) => {
				$(obj).addClass('is-reduced')
					  .outerHeight($(obj).prop('minHeight'));
			})
		});

		this.dom.$window.trigger('load');
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('accordion', {
	component: Accordion
});




// import owd from 'owd/owd';

// export default class Accordion extends owd.Component {
// 	init() {
//         this.item = this.$element.find('.accordion-item');
// 		this.bind();
// 	}

// 	bind() {
//         this.on('click', this.item, (e) => {
//             this.parent = $(e.target);
//             this.content = this.parent.find('.accordion-item-content');
//             this.holder = this.parent.find('.accordion-item-content-holder');            

//             if (this.parent.attr('aria-expanded') == 'false') {
//                 this.parent.addClass('is-expanded');
//                 this.content.stop().slideDown(300, () => {
//                     $(this).removeAttr('style');
//                 });
//                 this.parent.attr('aria-expanded', 'true');
//             } else {
//                 this.parent.removeClass('is-expanded');
//                 this.content.stop().slideUp(300, () => {
//                     $(this).removeAttr('style');
//                 });
//                 this.parent.attr('aria-expanded', 'false');
//             }
//         })
//     }

//     destroy() {
//         super.destroy();
//     }
// }

// owd.registerComponent('accordion', {
// 	component: Accordion
// });